import React from 'react';
import PropTypes from 'prop-types';
import HeaderType from './PropTypes/PVPartnerContentHeader';
import ContentRowsType from './PropTypes/PVPartnerContentRows';
import FooterType from './PropTypes/PVPartnerContentFooter';
import '../../../../Content/PVTemplate1.css';
import PVTemplate1HeaderWithForm from './PVTemplate1HeaderWithForm';
import PVTemplate1HeaderCatalog from './PVTemplate1HeaderCatalog';
import ContentRow from './PVTemplate1ContentRow';
import Footer from './PVTemplate1Footer';

const PVTemplate1WithForm = (props) => {
    const { data, templateHeader } = props;

    const TemplateHeader = () => {
        switch (templateHeader) {
            case 'PVTemplate1HeaderCatalog':
                return <PVTemplate1HeaderCatalog data={data.header} />;
            default:
                return <PVTemplate1HeaderWithForm data={data.header} />;
        }
    };

    const contentRows = data.contentRows.map((item, key) => (
        <ContentRow
            key={item.title}
            id={key}
            TemplateName={item.TemplateName}
            imgPath={item.imgPath}
            src={item.src}
            title={item.title}
            body={item.body}
            video={item.video}
            textAboveImage={item.textAboveImage}
        />
    ));

    const checkFooterData = data.footer === undefined ? '' : data.footer;

    return (
        <React.Fragment>
            <TemplateHeader />
            <div>{contentRows}</div>
            <Footer footer={checkFooterData} />
        </React.Fragment>
    );
};

PVTemplate1WithForm.propTypes = {
    data: PropTypes.shape({
        header: HeaderType,
        contentRows: ContentRowsType,
        footer: FooterType,
    }).isRequired,
    templateHeader: PropTypes.string,
};

PVTemplate1WithForm.defaultProps = {
    templateHeader: '',
};

export default PVTemplate1WithForm;
